export const bytesToKB = (bytes: number) => `${(bytes / 1024).toFixed(2)} KB`;
